import { CarrierInformationProvider } from 'components/MerchantTrackingWidget/context';
import { ShipmentLayout } from '../../../../../ShipmentLayout';
import { ShipmentDetails } from '../../../ShipmentDetails';
import { ReturnDetails } from '../../../ReturnDetails';

import { ReturnShipment as ReturnShipmentModel } from '../../../../models/ReturnShipment.model';
import { useCurrentShipment } from '../../../../../../hooks/useCurrentShipment';
import { FullReturnTrackingDetails } from './FullReturnTrackingDetails';

interface FullReturnShipmentProps {
  hasMultipleShipments: boolean;
}

export const FullReturnShipment = ({
  hasMultipleShipments,
}: FullReturnShipmentProps) => {
  const { shipment } = useCurrentShipment();
  const returnShipment = ReturnShipmentModel.create(shipment);

  const additionalContent = <ReturnDetails shipment={returnShipment} />;

  const parcelDetails = <ShipmentDetails shipment={returnShipment} />;

  const trackingDetails = (
    <FullReturnTrackingDetails
      shipment={shipment}
      hasMultipleShipments={hasMultipleShipments}
    />
  );

  return (
    <CarrierInformationProvider shipment={shipment}>
      <ShipmentLayout
        parcelDetails={parcelDetails}
        trackingDetails={trackingDetails}
        additionalContent={additionalContent}
      />
    </CarrierInformationProvider>
  );
};
